(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fh-jobs-listings"] && !Shopify.designMode) return;
  try {
    
(function() {
  const containers = document.querySelectorAll('.fh-jobs-listings__description[data-fh-richtext]');
  if (!containers.length) return;

  containers.forEach(container => {
    if (container.dataset.processed) return;
    container.dataset.processed = 'true';

    try {
      const raw = container.getAttribute('data-fh-richtext');
      const data = JSON.parse(raw);

      if (data && data.type === 'root' && Array.isArray(data.children)) {
        container.innerHTML = renderRichText(data.children);
      }
    } catch (e) {
      console.warn('FH Jobs: Could not parse richtext', e);
    }
  });

  function renderRichText(children) {
    return children.map(node => {
      if (node.type === 'paragraph') {
        const inner = node.children ? renderInlineNodes(node.children) : '';
        return '<p>' + inner + '</p>';
      }

      if (node.type === 'heading') {
        const level = node.level || 3;
        const inner = node.children ? renderInlineNodes(node.children) : '';
        return '<h' + level + '>' + inner + '</h' + level + '>';
      }

      if (node.type === 'list') {
        const tag = node.listType === 'ordered' ? 'ol' : 'ul';
        const items = (node.children || []).map(li => {
          const inner = li.children ? renderInlineNodes(li.children) : '';
          return '<li>' + inner + '</li>';
        }).join('');
        return '<' + tag + '>' + items + '</' + tag + '>';
      }

      return '';
    }).join('');
  }

  function renderInlineNodes(nodes) {
    return nodes.map(n => {
      if (n.type === 'text') {
        let text = escapeHtml(n.value || '');
        if (n.bold) text = '<strong>' + text + '</strong>';
        if (n.italic) text = '<em>' + text + '</em>';
        return text;
      }

      if (n.type === 'link') {
        const inner = n.children ? renderInlineNodes(n.children) : '';
        const href = n.url || '#';
        const target = n.target || '_blank';
        return '<a href="' + escapeHtml(href) + '" target="' + target + '" rel="noopener">' + inner + '</a>';
      }

      return '';
    }).join('');
  }

  function escapeHtml(str) {
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
